import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import '@fontsource/inter';
import { ThemeProvider } from '@mui/material/styles';
import {getCustomTheme} from "./pages/personalization/theme";
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useRole } from './helper/context/auth/authContext';
import { MenuProvider } from './helper/context/sideMenuContext/menuContext';

const ThemeWrapper = ({ children }) => {
  const { user } = useRole();
  const theme = useMemo(() => getCustomTheme(user), [user]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
        <MenuProvider>
          <ThemeWrapper>
            <App />
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  fontSize: '12px',
                  padding: 20,
                  borderRadius: '10px',
                  boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
                  height: 40
                },
              }}
            />
          </ThemeWrapper>
        </MenuProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
